import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
const tomos = [{
  icon: '📘',
  title: 'Tomo 1 — Lengua Española',
  subtitle: 'Palabras que Construyen',
  desc: 'Oralidad, lectura inicial, conciencia fonológica, comprensión lectora básica, primeras producciones escritas.',
  color: 'bg-blue-50 border-blue-100 text-blue-800'
}, {
  icon: '📗',
  title: 'Tomo 2 — Lengua Española',
  subtitle: 'Escritura que Comunica',
  desc: 'Producción de textos, gramática funcional, ortografía contextualizada, géneros textuales cotidianos e instructivos.',
  color: 'bg-emerald-50 border-emerald-100 text-emerald-800'
}, {
  icon: '📙',
  title: 'Tomo 3 — Matemática',
  subtitle: 'Números y Operaciones',
  desc: 'Numeración, conteo, sumas y restas en contexto, iniciación a la multiplicación, resolución de problemas reales.',
  color: 'bg-orange-50 border-orange-100 text-orange-800'
}, {
  icon: '📕',
  title: 'Tomo 4 — Matemática',
  subtitle: 'Geometría y Medida',
  desc: 'Figuras geométricas, orientación espacial, medición, cuerpos geométricos, estadística básica y juegos matemáticos.',
  color: 'bg-red-50 border-red-100 text-red-800'
}, {
  icon: '📓',
  title: 'Tomo 5 — Ciencias Biológicas',
  subtitle: 'El Mundo Vivo',
  desc: 'Cuerpo humano, salud y hábitos, seres vivos, ecosistemas locales, ciclos naturales y mini-investigaciones de aula.',
  color: 'bg-stone-100 border-stone-200 text-stone-800'
}, {
  icon: '📔',
  title: 'Tomo 6 — Evaluaciones y Rúbricas',
  subtitle: 'Sistema de Valoración EBI',
  desc: '24 evaluaciones listas para aplicar, rúbricas por área curricular, fichas de seguimiento individual y registro de logros del Tramo.',
  color: 'bg-amber-50 border-amber-100 text-amber-800'
}];
export const TomosGrid = () => {
  return <Section background="cream" data-id="element-362">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-363">
        <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-364">
          📚 LOS 6 TOMOS - TRAMO 2 EBI
        </h2>
        <p className="text-lg text-stone-600 font-medium" data-id="element-365">
          Cada tomo está diseñado para cubrir una unidad curricular completa con
          progresión pedagógica.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-366">
        {tomos.map((tomo, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: idx * 0.1
      }} className={`rounded-2xl p-6 md:p-8 border shadow-sm flex flex-col h-full ${tomo.color} bg-opacity-50`} data-id="element-367">
            <div className="text-4xl mb-4" data-id="element-368">{tomo.icon}</div>
            <h3 className="text-xl font-bold mb-1" data-id="element-369">{tomo.title}</h3>
            <div className="text-sm font-bold opacity-75 uppercase tracking-wider mb-4" data-id="element-370">
              {tomo.subtitle}
            </div>
            <p className="font-medium opacity-90 leading-relaxed mt-auto" data-id="element-371">
              {tomo.desc}
            </p>
          </motion.div>)}
      </div>
    </Section>;
};